import { getAddress, type Address } from "viem";

export type Token = {
  readonly symbol: string;
  readonly name: string;
  readonly address: Address;
  readonly decimals: number;
};

export const USDC: Token = {
  symbol: "USDC",
  name: "USD Coin",
  address: getAddress("0x833589fcd6edb6e08f4c7c32d4f71b54bda02913"),
  decimals: 6,
};

export const CADC: Token = {
  symbol: "CADC",
  name: "CAD Coin",
  address: getAddress("0x043eb4b75d0805c43d7c834902e335621983cf03"),
  decimals: 18,
};

export const TOKENS = { USDC, CADC } as const;
